import * as React from 'react';
import { DropdownButtonType, HierarchicalDropdownWidget, MenuItemInfo } from '@tableau/widgets';
import * as notificationStyles from '../styles/notificationStyles';
import { NotificationAction } from '../contentProviders/INotificationProvider';
import { Icons } from './Icons';

export interface NotificationActionsProps {
    notificationId: string;
    actions: Array<NotificationAction>;
    onKeyDown: (e: any) => void;
}

export function NotificationActions(props: NotificationActionsProps) {

    function createMenuItems(): MenuItemInfo[] {
        const menuItems: MenuItemInfo[] = [];
        props.actions.map((action, index) => menuItems.push({ displayValue: action.title, value: index.toString() }));
        return menuItems;
    }

    function onSelect(value: string) {
        props.actions[Number(value)].onClick();
    }

    function getIconButtonContent() {
        return <Icons.NotificationActionsMenu
            testId={'notificat-action-icon'}
            title={'notification actions'} />;
    }

    return (
        <HierarchicalDropdownWidget
            aria-haspopup={'dialog'}
            aria-label={'notification actions'}
            closeOnPopupBlur={false}
            testId={`notification-action-${props.notificationId}`}
            onSelect={onSelect}
            menuItemInfos={createMenuItems()}
            label={undefined}
            stackingRootId={'notification-panel'} // this is added as workaround of tfs1156753
            type={DropdownButtonType.Icon}
            children={getIconButtonContent()}
            className={notificationStyles.actionsButton}
            onKeyDown={props.onKeyDown}
        />);
}
